// removed by extract-text-webpack-plugin
module.exports = {"youtubeContainer":"_2BYPL74Bm7f-HhIhITSJtP","hoverWindow":"_2ZEfHFVaU2fRsEvc2BQNGq","menuButton":"_2cVlicT6ICXSLWwiiy8-YZ","active":"Iy-qOw7R8jcdzvHpEfmvd","kekek":"_32S_I7KDS6QSDuoHiNcyrV"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/containers/Landing/index.css
// module id = 298
// module chunks = 0